






































import 'reflect-metadata';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MappedItems } from './MappedItems';

@Component
export default class UnmappedTable extends Vue {
  @Prop() private readonly keyName!: string;
  @Prop() private readonly valueName!: string;
  @Prop() private readonly items!: string[];
  @Prop() private readonly onSave!: (changedItems: MappedItems) => void;

  private changedMappings = {};

  private updatedChangedMappings(value: string | undefined | null, key: string) {
    if (!value || value === '') {
      return;
    }

    this.changedMappings = {
      ...this.changedMappings,
      [key]: value.trim(),
    };
  }

  private async save() {
    if (Object.keys(this.changedMappings).length === 0) {
      return;
    }
    this.onSave(this.changedMappings);
  }
}
